<style lang="scss">
.infinite-box {
    overflow-y: auto;
    overflow-x: hidden;

    .infinite-box-more {
        clear: both;
        text-align: center;
        font-size: 14px;
        color: #c0c4cc;
    }
    .product-status {
        width: 8px;
        height: 8px;
        background: red;
        border-radius: 50%;
        float: left;
        margin-top: -14px;
        margin-left: -14px;
    }
    .product-boutique{
        width: 65px;
        height: 25px;
        background: #E6A23C;
        float: left;
        margin-top: -30px;
        margin-left: -40px;
        transform: rotate(-45deg);
    }

    .product-item {
        margin: 20px 30px;
        height: 480px;
        width: 300px;
        float: left;
    }
    .product-img-mian {
        height: 260px;
        width: 260px;
    }

    .product-imgs {
        .product-img {
            height: 80px;
            width: 80px;
            margin-left: 6px;
        }

        margin-top: 5px;
    }
    .product-more {
        float: right;
        line-height: 0;
        margin-top: -18px;
        cursor: pointer;
        margin-right: -13px;
    }

    .product-name,
    .product-category,
    .product-code {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .product-name {
        font-size: 14px;
    }

    .product-category,
    .product-code {
        font-size: 12px;
    }

    .product-seleted {
        font-size: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        text-align: center;
    }

    .product-time {
        font-size: 12px;
        color: #c0c4cc;
        float: left;
        width: 160px;
        margin-top: 5px;
    }

    .product-remark {
        height: 45px;
        margin: 0;
        overflow: auto;
    }
    .product-region {
        overflow: hidden;
        font-size: 14px;
        color: #ccc;
        height: 19px;
    }

    .product-links {
        float: left;
        width: 100%;
        height: 22px;

        .product-link {
            margin-left: 5px;
            float: right;
            margin-top: 3px;
        }
    }

    .el-carousel__button {
        background-color: #ccc !important;
    }

    .product-totle-box{
        width: 50px;
        height: 24px;
        position: absolute;
        bottom: 10px;
        right: 20px;
        font-size: 12px;
        color: #c0c4cc;
    }
}
</style>

<template>
    <div class="product-list">
        <div
            class="infinite-box"
            :style="'height:' + height + 'px'"
            v-infinite-scroll="next"
            :infinite-scroll-disabled="disabled()"
            infinite-scroll-delay="400"
        >
            <el-card class="product-item box-card" v-for="(item, i) in products" :key="i">
                <div class="product-status" v-show="item.status != 'Y'" title="未上架"></div>
                <div class="product-boutique" v-show="item.status == 'Y' && item.isBoutique == 'Y'" title="精品"></div>

                <el-dropdown class="product-more" @command="handleCommand" v-if="isRoot">
                    <i class="el-icon-more-outline"></i>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="{id: item.id, type: 'e'}">编辑</el-dropdown-item>
                        <el-dropdown-item
                            :command="{id: item.id, type: 'Y', name: item.name}"
                            v-if="item.status != 'Y'"
                        >上架</el-dropdown-item>
                        <el-dropdown-item
                            :command="{id: item.id, type: 'N', name: item.name}"
                            v-if="item.status == 'Y'"
                        >下架</el-dropdown-item>
                        <el-dropdown-item :command="{id: item.id, type: 'b', name: item.name}" v-if="item.status == 'Y' && item.isBoutique != 'Y'">标为精品</el-dropdown-item>
                        <el-dropdown-item :command="{id: item.id, type: 'cb', name: item.name}" v-if="item.status == 'Y' &&  item.isBoutique == 'Y'">取消精品</el-dropdown-item>
                        <el-dropdown-item :command="{id: item.id, type: 'd', name: item.name}">删除</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-image
                    class="product-img-mian"
                    :src="'/api/alibaba/product/base64?id=' + item.id + '&field=MAIN_IMG_BASE'"
                    :preview-src-list="getImg(item.mainImg)"
                ></el-image>

                <div class="product-name">
                    <el-tooltip placement="bottom" effect="light">
                        <el-link>{{ item.name }}</el-link>
                        <div slot="content">
                            <div>阶梯数量：{{ getStepsInfo(item.steps) }}</div>
                            <div>阶梯价格：{{ getStepsInfoNumber(item.steps) }}</div>

                            <div v-if="item.remark">备注：<pre class="product-remark">{{ item.remark }}</pre> </div>
                        </div>
                    </el-tooltip>
                </div>

                <div class="product-category">类目：{{ item.categoryName }} 编码：{{ item.code }}</div>
                <div class="product-region" v-if="item.region">主营：{{ item.region }}</div>
                <div class="product-region" v-else></div>

                <div class="product-imgs">
                    <el-image
                        class="product-img"
                        :src="'/api/alibaba/product/base64?id=' + item.id + '&field=IMG_ONE_BASE'"
                        :preview-src-list="getImg(item.imgOne)"
                    ></el-image>
                    <el-image
                        class="product-img"
                        :src="'/api/alibaba/product/base64?id=' + item.id + '&field=IMG_TWO_BASE'"
                        :preview-src-list="getImg(item.imgTwo)"
                    ></el-image>
                    <el-image
                        class="product-img"
                        :src="'/api/alibaba/product/base64?id=' + item.id + '&field=IMG_THREE_BASE'"
                        :preview-src-list="getImg(item.imgThree)"
                    ></el-image>
                </div>

                <div class="product-links">
                    <div
                        class="product-time"
                    >{{ item.creatorName }} 于 {{ $tools.timestampToDay(item.createTime) }} 创建</div>

                    <el-link
                        v-show="item.zip && item.zip != -1"
                        class="product-link"
                        type="success"
                        @click="downloadZip(item.zip)"
                    >下载</el-link>
                    <el-link
                        v-show="item.status == 'Y'"
                        class="product-link"
                        type="primary"
                        @click="seleteProduct(item.id)"
                    >选入</el-link>

                    <el-link
                        v-show="isRoot && item.link"
                        class="product-link"
                        type="danger"
                        @click="onCopy(item.link)"
                    >采购</el-link>
                </div>

                <el-carousel class="product-seleted" height="35px" :autoplay="false" arrow="never">
                    <el-carousel-item v-for="item in item.seleteInfo" :key="item">{{ item.creatorName }} 于 {{ $tools.timestampToDay(item.createTime) }}  选入 {{item.shopName}}</el-carousel-item>
                </el-carousel>
            </el-card>
            
            <div class="product-totle-box" v-if="params.total > 0">
                <span v-if="params.current < params.pages">{{10 * params.current}}/{{params.total}}</span>
                <span v-else>{{params.total}}/{{params.total}}</span>
            </div>

            <div class="infinite-box-more">
                <p v-if="!disabled()">加载中....</p>
                <p v-if="disabled()">没有更多了...</p>
            </div>
        </div>

        <el-dialog title="选入产品" width="400px" :visible.sync="showSelete" class="selete-dloaig">
            <el-checkbox-group v-model="checkList">
                <el-checkbox :disabled="item.valid == 'N'" :label="item.id" v-for="(item, i) in shops" :key="i">{{item.name}}</el-checkbox>
            </el-checkbox-group>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="doSelete">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        height: { type: Number, default: 100 },
        searchParams: { type: Object, default: null },
        editFuc: { type: Function, default: null },
        isRoot: { type: Boolean, default: false },
        action: { type: String, default: false },
        isRelease: { type: Boolean, default: false },
    },
    data() {
        return {
            params: {},
            products: [],
            imgId: null,
            preview: [],
            previewId: null,
            showSelete: false,
            shops: null,
            checkList: [],
            proId: null
        };
    },
    methods: {
        disabled() {
            return (
                this.params.current >= this.params.pages ||
                this.params.total == 0
            );
        },
        next() {
            this.params.current =
                (this.params.current ? this.params.current : 0) + 1;
            this.search();
        },
        search() {
            let _this = this;

            if (_this.searchParams.shopsArr)  {
                _this.searchParams.shops = _this.searchParams.shopsArr.join(",")
            }

            if (_this.searchParams.regionArr)  {
                _this.searchParams.region = _this.searchParams.regionArr.join(",")
            }

            if (_this.searchParams.categoryArr)  {
                _this.searchParams.category = _this.searchParams.categoryArr.join(",")
            }

            _this.$http.post(
                [
                    _this.action ? _this.action : "alibaba/product/mypage",
                    _this.params,
                    _this.searchParams,
                ],
                [
                    function (data) {
                        _this.params.pages = data.pages;
                        _this.params.total = data.total;
                        _this.params.current = data.current;
                        _this.products = _this.products.concat(data.records);
                    },
                ],
                ".product-list"
            );
        },
        relaod() {
            this.products = [];
            this.params = { current: 0, pages: 0, total: 0 };
            this.search();
        },
        downloadZip(id) {
            window.open("/api/alibaba/product/download?id=" + id, "_blank");
        },
        getImg(id) {
            return ["/api/alibaba/product/download?id=" + id];
        },
        vimg(id, index) {
            alert(id);
            this.preview = ["/api/alibaba/product/download?id=" + id];
            document.getElementById("imgView").click();
        },
        handleCommand(obj) {
            if (obj.type == "e") {
                this.edit(obj.id);
            } else if (obj.type == "d") {
                this.del(obj.id, obj.name);
            } else if (obj.type == "N" || obj.type == "Y") {
                this.upStatus(obj.id, obj.name, obj.type);
            } else if (obj.type == "b" || obj.type == "cb") {
                this.upBoutique(obj.id, obj.name, obj.type);
            }
        },
        edit(id) {
            if (this.editFuc) {
                this.editFuc(id);
            }
        },
        del(id, name) {
            let _this = this;

            _this.$tConfirm.show(
                "确认删除【" + name + "】以及包含的图片? ",
                function () {
                    _this.$http.post(
                        [_this.isRelease ? "alibaba/product/deleteMyrelease" : "alibaba/product/delete", { id: id }],
                        [
                            function (data, msg) {
                                msg("删除成功");
                                _this.relaod();
                            },
                        ],
                        ".product-list"
                    );
                }
            );
        },
        upStatus(id, name, status) {
            let _this = this;

            _this.$tConfirm.show(
                "确认" +
                    (status == "Y" ? "上架" : "下架") +
                    "【" +
                    name +
                    "】? ",
                function () {
                    _this.$http.post(
                        [_this.isRelease ? "alibaba/product/saveMyrelease" : "alibaba/product/save", { id: id, status: status }],
                        [
                            function (data, msg) {
                                for (var i in _this.products) {
                                    if (_this.products[i].id == id) {
                                        _this.products[i].status = status;
                                    }
                                }

                                msg(status == "Y" ? "上架成功" : "下架成功");
                            },
                        ],
                        ".product-list"
                    );
                }
            );
        },
        upBoutique(id, name, status) {
            let _this = this;

            _this.$tConfirm.show(
                "确认" +
                    (status == "b" ? "标为精品" : "取消精品") +
                    "【" +
                    name +
                    "】? ",
                function () {
                    _this.$http.post(
                        [_this.isRelease ? "alibaba/product/saveMyrelease" : "alibaba/product/save", { id: id, isBoutique: (status == 'b' ? 'Y' : 'N' )}],
                        [
                            function (data, msg) {
                                for (var i in _this.products) {
                                    if (_this.products[i].id == id) {
                                        _this.products[i].isBoutique = (status == 'b' ? 'Y' : 'N');
                                    }
                                }

                                msg("修改成功");
                            },
                        ],
                        ".product-list"
                    );
                }
            );
        },
        onCopy(msg) {
            let _this = this;

            _this.$copyText(msg).then(function (e) {
                _this.$message({
                    message: "获取地址成功",
                    type: "success",
                });
            });
        },
        seleteProduct(id) {
            let _this = this;

            _this.$http.post(
                ["alibaba/product/validSelete", {id : id}],
                [
                    function (data) {
                        _this.checkList = [];
                        
                        for (var i in data) {
                            if (data[i].checked  == 'Y') {
                                _this.checkList.push(data[i].id);
                            }
                        }
                        
                        _this.proId = id;
                        _this.shops = data;
                        
                        _this.showSelete = true;
                    },
                ],
                ".product-list"
            );
        },
        doSelete() {
            let _this = this;

            _this.$http.post(
                ["alibaba/product/selete", {productId: _this.proId, shopIds: _this.checkList.join(",")}],
                [
                    function (data, msg) {
                        _this.showSelete = false;
                        msg("操作成功");
                    },
                ],
                ".product-list"
            );
        },
        getStepsInfo(info) {
            try {
                var h = [];
                var info = eval(info);

                for (var i in info) {
                    h.push(info[i][0]);
                }

                return h.join("~");
            } catch (error) {
                console.error(error)
            }

            return "";
        },
        getStepsInfoNumber(info) {
            try {
                var h = [];
                var info = eval(info);

                for (var i in info) {
                    h.push(info[i][1]);
                }

                return h.join("~");
            } catch (error) {
                console.error(error)
            }

            return "";
        }
    },
    mounted() {
        this.search();
    },
};
</script>